import { useAtomValue, useSetAtom } from "jotai";
import { HideIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseHideButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useHideButton({ setActiveSubMenu }: UseHideButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("hide"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const uniqueValues = [...new Set(options.map((option) => option.value))];

    const isActive = uniqueValues.length === 1 && (uniqueValues[0] as boolean);

    const handleClick = () => {
        setActiveSubMenu(null);

        const setHideOptions = setNewOptions({ name: "hide", setWidgetMenuOptions });

        applyValue({ options, value: !isActive, setNewOptions: setHideOptions });
    };

    const content = <HideIcon className={isActive ? styles.svgStrokeActive : ""} />;
    const tippyContent = isActive ? "Показать" : "Скрыть";

    return {
        content,
        handleClick,
        isActive,
        tippyContent,
    };
}
